var _circle, _path, _path2, _rect, _rect2, _path3, _rect3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearBreathingApparatus50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.838,15.04C34.208,11.792,31.667,9,27,9c-5.44,0-8,3.792-8,7.68V17h18v-0.964L34.838,15.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,38h6v-7c0-1.657-1.343-3-3-3l0,0c-1.657,0-3,1.343-3,3V38z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    x: 14,
    y: 26,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 13,
    y: 25,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.553,27.395C29.292,27.264,27,25.975,27,21v-5h2v5c0,3.704,1.462,4.612,1.477,4.621L29.553,27.395 z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.531,
    height: 2,
    x: 35.263,
    y: 24.772,
    fill: "#fff",
    transform: "rotate(-65.557 37.528 25.771)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28,17h1v1.212c0,0.392,0.229,0.748,0.586,0.91L35,21.585V22.6L33.5,26H29l-1.011-2.778L28,17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.052,19.195c-0.117-1.129,0.101-2.23,0.562-3.195H20.46c-0.367,1.067-0.519,2.224-0.397,3.402 c0.187,1.801,0.765,3.138,1.23,4.212C21.688,24.527,22,25.249,22,26v2.774c-0.431,0.938-2,4.663-2,9.226h2 c0-4.687,1.876-8.516,1.895-8.554L24,29.234V26c0-1.165-0.423-2.144-0.872-3.179C22.676,21.773,22.207,20.69,22.052,19.195z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.644,27l2.272-5l-1.13-6h-2.042c0.006,0.021,0.016,0.038,0.023,0.06l1.067,5.689L32.356,25H29 l0.003,4.497l0.394,0.301C29.544,29.91,33,32.607,33,38h2c0-5.336-2.91-8.475-4-9.463V27H33.644z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearBreathingApparatus50);
export default __webpack_public_path__ + "static/media/icons8-wear-breathing-apparatus-50.bfc16dccdd43256b4923718aaf5c3f19.svg";
export { ForwardRef as ReactComponent };